const containers = document.querySelectorAll('.latest-articles__cards');

function initializeLatestArticles(container) {
    const button = document.querySelector(`.js-latest-articles-load-more[data-target="#${container.id}"]`);

    if (!button) {
        return;
    }

    button.addEventListener('click', () => revealNextBatch(container, button));
}

function revealNextBatch(container, button) {
    const LOAD_MORE_BATCH_SIZE = 6;
    const hiddenCards = container.querySelectorAll('.latest-articles__card.d-none');

    hiddenCards.forEach((card, index) => {
        if (index < LOAD_MORE_BATCH_SIZE) {
            card.classList.remove('d-none');
        }
    });

    updateSummary(container, hiddenCards.length, LOAD_MORE_BATCH_SIZE);

    if (hiddenCards.length <= LOAD_MORE_BATCH_SIZE) {
        button.remove();
    }
}

function updateSummary(container, hiddenCountBeforeReveal, batchSize) {
    const summary = container.parentElement.querySelector('.js-latest-articles-summary');

    if (!summary) {
        return;
    }

    const totalCount = container.querySelectorAll('.latest-articles__card').length;
    const remainingHiddenCount = Math.max(hiddenCountBeforeReveal - batchSize, 0);
    const shownCount = totalCount - remainingHiddenCount;

    summary.textContent = `Showing ${shownCount} of ${totalCount} articles`;
}

containers.forEach((container) => {
    initializeLatestArticles(container);
});

export {initializeLatestArticles};
